import { BaseService } from "@/services/BaseService";
import {
  AggregateStorageStatsDto,
  RegionStorageStatsDto,
  TenantFilesFilters,
  TenantStorageFilesDto,
  TenantStorageFilters,
  TenantStorageUsageListDto,
} from "@/types/admin-storage";

class AdminStorageService extends BaseService {
  private basePath = "/admin/monitoring/storage";

  async getStorageRegions(): Promise<AggregateStorageStatsDto> {
    return this.get<AggregateStorageStatsDto>(`${this.basePath}/regions`);
  }

  async getStorageRegion(code: string): Promise<RegionStorageStatsDto> {
    return this.get<RegionStorageStatsDto>(
      `${this.basePath}/regions/${encodeURIComponent(code)}`,
    );
  }

  async getTenants(
    filters: TenantStorageFilters,
  ): Promise<TenantStorageUsageListDto> {
    return this.get<TenantStorageUsageListDto>(`${this.basePath}/tenants`, {
      region: filters.region,
      search: filters.search || undefined,
      status: filters.status || undefined,
      sortBy: filters.sortBy,
      sortOrder: filters.sortOrder,
      limit: filters.limit,
      offset: filters.offset,
    });
  }

  async getTenantFiles(
    tenantId: string,
    filters: TenantFilesFilters,
  ): Promise<TenantStorageFilesDto> {
    let uploaded: "true" | "false" | undefined;
    if (filters.uploaded === true) uploaded = "true";
    else if (filters.uploaded === false) uploaded = "false";

    return this.get<TenantStorageFilesDto>(
      `${this.basePath}/tenants/${tenantId}`,
      {
        search: filters.search || undefined,
        uploaded,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
        limit: filters.limit,
        offset: filters.offset,
      },
    );
  }
}

export const adminStorageService = new AdminStorageService();
